import { render, staticRenderFns } from "./TepLiquidacionIndex.vue?vue&type=template&id=4f8ef7b6"
import script from "./TepLiquidacionIndex.vue?vue&type=script&lang=js"
export * from "./TepLiquidacionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports